import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Avatar, Menu, Badge } from '@mantine/core';
import { AccountSwitchOptionsProps } from '@common/types/types';
import LogoutButton from '../LogoutButton';
import { useAppSelector } from 'src/store';
import { useNavigate } from 'react-router-dom';

import styles from './styles.module.scss';
const AccountMenu: FC<AccountSwitchOptionsProps> = ({ options, data, onChange }) => {
  const [t] = useTranslation('nav');
  const navigate = useNavigate();
  const { data: user } = useAppSelector((state) => state.user);
  const plan = useAppSelector((state) => state.payment.data.paymentPlan);
  return (
    <Menu position="top-end" offset={4} withArrow shadow="md" width={250} >
      <Menu.Target>
        <Avatar variant='filled' color="#264547" radius="xl">{user?.firstName?.slice(0, 1).toUpperCase() + '' + user?.lastName.slice(0, 1).toUpperCase()}</Avatar>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label px={0}>
          <Flex p={0} align={"center"} gap={"sm"}>
            <Avatar variant='filled' color="#264547" radius="xl">{user?.firstName?.slice(0, 1).toUpperCase() + '' + user?.lastName.slice(0, 1).toUpperCase()}</Avatar>
            <Flex direction={"column"}>
              <p style={{ margin: 0, color: "#000", fontSize: '15px' }}>
                {user?.firstName + ' ' + user?.lastName}
              </p>
              <p style={{ margin: 0, color: "#000", fontSize: '15px' }}>
                {user?.email}
              </p>
            </Flex>
          </Flex>

        </Menu.Label>
        <Menu.Item  onClick={() =>  navigate('/account/account-details')}>
         <Flex align={"center"} gap={"xs"}>
          Account
          { ['free', 'free plan'].includes(plan.toLocaleLowerCase())  && <Badge variant="outline" color="green">Upgrade</Badge>  }
         </Flex>
        </Menu.Item>
        {/* <Menu.Item className=''  onClick={() => navigate('/account/account-details/billings')}>
          Billing
          <Badge variant="outline" color="green">Badge</Badge>;
        </Menu.Item> */}
        <Menu.Divider />
        <Menu.Label>{user?.company_name}</Menu.Label>
        <Menu.Item onClick={() => plan != 'free' && navigate('/account/organisations')} >
          <Flex align={"center"} gap={"xs"}>
            Companies
            { ['free', 'free plan'].includes(plan.toLocaleLowerCase()) && <Badge variant="outline" color="green">Upgrade</Badge>  }
          </Flex>
        </Menu.Item>
        <Menu.Item
          color="red"
          p={0}
        >
          <LogoutButton data-menu-item className={styles.logoutBtn} />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default AccountMenu;

function getPreviousIndex(current: number, elements: HTMLButtonElement[], loop: boolean): number {
  for (let i = current - 1; i >= 0; i -= 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }

  if (loop) {
    for (let i = elements.length - 1; i > -1; i -= 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }

  return current;
}

function getNextIndex(current: number, elements: HTMLButtonElement[], loop: boolean): number {
  for (let i = current + 1; i < elements.length; i += 1) {
    if (!elements[i].disabled) {
      return i;
    }
  }

  if (loop) {
    for (let i = 0; i < elements.length; i += 1) {
      if (!elements[i].disabled) {
        return i;
      }
    }
  }

  return current;
}

interface GetElementsSiblingsInput {
  /** Selector used to find element siblings, e.g. '[data-tab]' */
  siblingSelector: string;
  /** Determines whether next/previous indices should loop */
  loop?: boolean;
  /** External keydown event */
  onKeyDown?(event: React.KeyboardEvent<HTMLDivElement>): void;
}

export function createScopedKeydownHandler({
  siblingSelector,
  onKeyDown,
  loop = true,
}: GetElementsSiblingsInput) {
  return (event: React.KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(event);

    const elements = Array.from(event.currentTarget?.querySelectorAll<HTMLButtonElement>(siblingSelector) || []);

    const current = elements.findIndex((el) => document.activeElement === el);
    const _nextIndex = getNextIndex(current, elements, loop);
    const _previousIndex = getPreviousIndex(current, elements, loop);

    switch (event.key) {
      case 'ArrowUp': {
        event.stopPropagation();
        event.preventDefault();
        elements[_previousIndex].focus();

        break;
      }

      case 'ArrowDown': {
        event.stopPropagation();
        event.preventDefault();
        elements[_nextIndex].focus();

        break;
      }

      case 'Home': {
        event.stopPropagation();
        event.preventDefault();
        !elements[0].disabled && elements[0].focus();
        break;
      }

      case 'End': {
        event.stopPropagation();
        event.preventDefault();
        const last = elements.length - 1;
        !elements[last].disabled && elements[last].focus();
        break;
      }
    }
  };
}
